<app-pageheader [Parent]="this">
  @if (ModelIsNew==false) {
    <app-form-delete-button [Parent]="this" [Form]="Form" [Model]="Model"
      DeleteUrl="enforcement/noticetriggersets/" DeleteNavLink="/enforcement/notices/noticetriggersets" [DeleteCheck]="false">
    </app-form-delete-button>
  }
  <app-form-save-button [Parent]="this" [Form]="Form" class="button is-primary" (OnSave)="Save()">
  </app-form-save-button>
</app-pageheader>

<app-loader [Parent]="this"></app-loader>

@if (FormLoaded) {
  <div [formGroup]="Form">
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">Notice Trigger Set</p>
          <div class="panel-block is-block">
            <app-field Label="Name">
              <div class="control">
                <input formControlName="Name" class="input" type="text" placeholder="e.g. Generic Notice Trigger Set" />
                <app-validator [For]="Form.get('Name')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Only Most Recent Due Notice">
              <div class="control">
                <label class="checkbox">
                  <input type="checkbox" formControlName="OnlyMostRecentNotice" />
                  Generate only the highest due notice (don’t backfill earlier notices)
                </label>
              </div>
            </app-field>
            <app-field Label="Escalation Provider">
              <div class="control">
                <div class="select is-fullwidth">
                  <select formControlName="EscalationProviderType">
                    @for (p of escalationProviders; track p) {
                      <option [value]="p.Id">{{p.Name}}</option>
                    }
                  </select>
                </div>
                <app-validator [For]="Form.get('EscalationProviderType')"></app-validator>
              </div>
            </app-field>
          </div>
        </article>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <article class="panel">
          <div class="panel-heading triggers-heading">
            <span>Triggers</span>
            <button type="button" class="button is-link is-light" (click)="addTrigger()">
              <span class="icon"><i class="fas fa-plus"></i></span>
              <span>Add Trigger</span>
            </button>
          </div>
          <div class="panel-block">
            @if (Model?.Triggers?.length && !(Model.Triggers[Model.Triggers.length - 1]?.ActionType == 1)) {
              <div class="message is-warning is-light">
                <div class="message-body">
                  The last trigger is not set to <strong>Raise to collections</strong>. Due dates in templates will default to <strong>30 days</strong> for the last notice.
                </div>
              </div>
            }
            @if (Model.Triggers && Model.Triggers.length > 0) {
              <div class="trigger-list">
                @for (t of Model.Triggers; track t; let i = $index) {
                  <div class="trigger-row">
                    <div class="trigger-move">
                      <div class="buttons are-small trigger-move-buttons">
                        <button type="button" class="button is-light" title="Move up" (click)="moveTriggerUp(i)" [disabled]="i === 0">
                          <span class="icon is-small"><i class="fas fa-chevron-up"></i></span>
                        </button>
                        <button type="button" class="button is-light" title="Move down" (click)="moveTriggerDown(i)" [disabled]="i === (Model.Triggers.length - 1)">
                          <span class="icon is-small"><i class="fas fa-chevron-down"></i></span>
                        </button>
                      </div>
                    </div>
                    <div class="trigger-sentence">
                      <span>After</span>
                      <input class="input is-small trigger-days" type="number"
                        [(ngModel)]="t.DaysAfterCreated"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="Form.markAsDirty()" />
                        <span>days,</span>
                        <div class="select is-small is-fullwidth trigger-template">
                          <select [ngModel]="triggerActionValue(t)"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="setTriggerActionFromValue(t, $event)">
                            <optgroup label="Send Document Template">
                              @for (dt of templates; track dt) {
                                <option [value]="'template:' + dt.Id">{{dt.Name}}</option>
                              }
                            </optgroup>
                            <option value="raise">Escalate to collections ({{getEscalationProviderName()}})</option>
                          </select>
                        </div>
                      </div>
                      <div class="trigger-remove">
                        <button type="button" class="button is-danger is-light is-small" (click)="removeTrigger(i)">
                          <span class="icon is-small"><i class="fas fa-times"></i></span>
                        </button>
                      </div>
                    </div>
                  }
                </div>
              } @else {
                <div class="has-text-grey is-italic">No triggers yet.</div>
              }
            </div>
          </article>
        </div>
      </div>
    </div>
  }

